import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { logger } from '@/services/logger'
import { getReports, postReportEmbedUrl } from '@/services/reports'
import { REPORT_TABS } from '@/constants/reports'
import type { AvailableReport, ReportDashboard } from '@/types/reports.types'

export const useReportsStore = defineStore('reports', () => {
  const dashboards = ref<ReportDashboard[]>([])
  const isLoading = ref(false)
  const hasError = ref(false)

  const availableReports = computed<AvailableReport[]>(() =>
    REPORT_TABS.flatMap(({ name, labelKey }) => {
      const dashboard = dashboards.value.find((item) => item.name === name)

      return dashboard ? [{ id: dashboard.id, name, labelKey }] : []
    })
  )

  const hasReports = computed(() => availableReports.value.length > 0)

  const fetchReports = async () => {
    isLoading.value = true
    hasError.value = false

    try {
      const { data } = await getReports()

      dashboards.value = data.dashboards ?? []
    } catch (error) {
      dashboards.value = []
      hasError.value = true
      logger.error(error)
    } finally {
      isLoading.value = false
    }
  }

  const fetchEmbedUrl = async (dashboardId: string) => {
    const { data } = await postReportEmbedUrl(dashboardId)

    return data.embedUrl
  }

  return {
    availableReports,
    dashboards,
    fetchEmbedUrl,
    fetchReports,
    hasError,
    hasReports,
    isLoading
  }
})
